import ItemBlindTitle from './ItemBlindTitle';
import SummaryTop from './SummaryTop';
import SummaryReview from './SummaryReview';
import OptionViewDetailImage from './OptionViewDetailImage';
import NoImage from './NoImage';

function SummaryContents(imageInfo, optionOrder) {
  if (imageInfo.length === 0) return NoImage('f');

  function getViewPrice() {
    const { dealSummaryInfo } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
    if (!dealSummaryInfo || !dealSummaryInfo.summaryContents) return 'Y';
    return dealSummaryInfo.summaryContents.viewPrice;
  }

  return [
    SummaryTop(imageInfo, optionOrder, getViewPrice()),
    SummaryReview(imageInfo)
  ].join('');
}

function Contents(imageInfo, optionOrder) {
  const { contentType } = TMON.oApp.htStorage.htStaticData.htDealContentInfo;
  if (contentType === 'SUMMARY') return SummaryContents(imageInfo, optionOrder);
  if (contentType === 'OPTION_VIEW_DETAIL') return OptionViewDetailImage(imageInfo);
  return '';
}

export const OptionDetailItem = (imageInfo, optionOrder, options) => {
  return [
    `<li class="swipe-item swiper-slide" data-order="${optionOrder}">`,
    ItemBlindTitle(options, optionOrder),
    Contents(imageInfo, optionOrder),
    '</li>'
  ].join('');
};

function OptionDetailItems(imageList, orderNo) {
  if (imageList.length === 0) return [];

  const lastOrderNo = imageList.length - 1;
  if (imageList.length === 1) return [imageList[lastOrderNo]];
  if (orderNo === 0) return [imageList[lastOrderNo], imageList[0], imageList[1]];
  if (orderNo === lastOrderNo) return [imageList[orderNo - 1], imageList[orderNo], imageList[0]];
  return imageList.slice(orderNo - 1, orderNo + 2);
}

export const OptionDetailContainer = (imageList, options, orderNo) => {
  return [
    '<ul id="pcSliderOptionDetail" class="swiper-wrapper">',
    OptionDetailItems(imageList, orderNo).map(
      (item) => OptionDetailItem(item, item.nOrderNo, options)
    ).join(''),
    '</ul>'
  ].join('');
};
